import { BanIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import Modal from "../../shared/components/ModalWindow";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type RequestFailModalProps = {
  isModalOpen: boolean;
  title: string;
  caption: string;
  onDismiss?: () => void;
};

export function RequestFailModal({ isModalOpen, title, caption, onDismiss }: RequestFailModalProps) {
  const theme = useAtomValue(themeAtom);

  return (
    <Modal isOpen={isModalOpen} closeModal={console.log}>
      <div className={twMerge("flex flex-col items-center p-4", theme.home.tailwind.textDefault)}>
        <BanIcon className="h-14 w-14" color="#Af0002" />

        <div className="pb-4 pt-8 text-center font-bold">{title}</div>

        <div className={twMerge("pb-10 text-center text-sm", theme.uwhcAssistant.text)}>{caption}</div>
        <button
          className={twMerge(
            "w-[220px] rounded border bg-green px-4 py-2",
            theme.warningFunction.text,
            theme.uwhcAssistant.border,
          )}
          onClick={onDismiss}
        >
          Try again
        </button>
      </div>
    </Modal>
  );
}
